import { getTreeCreation } from 'tilli-core/dist/trees/treeHelpers';
import getInitialState from '../step1InitialState';
import getInitialStateProp from './preFilledClothes.getInitialStateProp';

const getPreFilledClothes = (t) => {
  const treeCreation = getTreeCreation(t);
  const treeCreaBag = treeCreation.find(({ slug }) => slug === 'crea_sac');
  const treeCreaCushion = treeCreation.find(({ slug }) => slug === 'crea_hous');
  const treeCreaClutch = treeCreation.find(({ slug }) => slug === 'crea_poch');

  return {
    balzacBag: {
      ...getInitialState(),
      creationSlug: 'crea_sac',
      creationSecondOption: treeCreaBag
        .questions.find(({ slug }) => slug === 'closing')
        .answers.find(({ slug }) => slug === 'zipClosing'),
      creationFirstOption: treeCreaBag
        .questions.find(({ slug }) => slug === 'handle')
        .answers.find(({ slug }) => slug === 'chainHandle'),
      creationShape: treeCreaBag
        .questions.find(({ slug }) => slug === 'shape')
        .answers.find(({ slug }) => slug === 'COMPLEX'),
      creationSize: treeCreaBag
        .questions.find(({ slug }) => slug === 'size')
        .answers.find(({ slug }) => slug === 'SMALL'),
      selectedCategory: 'clothes',
      selectedCloth: '',
      selectedCreationNumberOfPieces: 1,
      selectedFabric: '',
      selectedTypeOfWork: 'creation',
      otherItems: ['9.crea_sac-supp-1', '9.crea_sac-supp-2', '9.crea_sac-supp-3'],
    },
    balzacCushion: {
      ...getInitialState(),
      creationSlug: 'crea_hous',
      creationSecondOption: treeCreaCushion
        .questions.find(({ slug }) => slug === 'closing')
        .answers.find(({ slug }) => slug === 'invisibleZip'),
      creationFirstOption: {},
      creationShape: treeCreaCushion
        .questions.find(({ slug }) => slug === 'shape')
        .answers.find(({ slug }) => slug === 'SIMPLE'),
      creationSize: treeCreaCushion
        .questions.find(({ slug }) => slug === 'size')
        .answers.find(({ slug }) => slug === 'BIG'),
      selectedCategory: 'clothes',
      selectedCloth: '',
      selectedCreationNumberOfPieces: 1,
      selectedFabric: '',
      selectedTypeOfWork: 'creation',
    },
    balzacClutch: {
      ...getInitialState(),
      creationSlug: 'crea_poch',
      creationSecondOption: treeCreaClutch
        .questions.find(({ slug }) => slug === 'closing')
        .answers.find(({ slug }) => slug === 'pressStudClosing'),
      creationFirstOption: treeCreaClutch
        .questions.find(({ slug }) => slug === 'handle')
        .answers.find(({ slug }) => slug === 'noHandle'),
      creationShape: treeCreaClutch
        .questions.find(({ slug }) => slug === 'shape')
        .answers.find(({ slug }) => slug === 'SIMPLE'),
      creationSize: treeCreaClutch
        .questions.find(({ slug }) => slug === 'size')
        .answers.find(({ slug }) => slug === 'BIG'),
      selectedCategory: 'clothes',
      selectedCloth: '',
      selectedCreationNumberOfPieces: 1,
      selectedFabric: '',
      selectedTypeOfWork: 'creation',
      otherItems: ['9.crea_poch-ferm-2', '9.crea_poch-supp-1', '9.crea_poch-supp-2'],
    },
    balzacBigBag: {
      ...getInitialState(),
      creationSlug: 'crea_sac',
      creationSecondOption: treeCreaBag
        .questions.find(({ slug }) => slug === 'closing')
        .answers.find(({ slug }) => slug === 'pressStudClosing'),
      creationFirstOption: treeCreaBag
        .questions.find(({ slug }) => slug === 'handle')
        .answers.find(({ slug }) => slug === 'chainHandle'),
      creationShape: treeCreaBag
        .questions.find(({ slug }) => slug === 'shape')
        .answers.find(({ slug }) => slug === 'SIMPLE'),
      creationSize: treeCreaBag
        .questions.find(({ slug }) => slug === 'size')
        .answers.find(({ slug }) => slug === 'BIG'),
      selectedCategory: 'clothes',
      selectedCloth: '',
      selectedCreationNumberOfPieces: 1,
      selectedFabric: '',
      selectedTypeOfWork: 'creation',
      otherItems: ['9.crea_sac-supp-1'],
    },
  };
};

export { getInitialStateProp };

export default getPreFilledClothes;
